import React from 'react'
import { Route, IndexRoute } from 'react-router'
import getPath from '../shared/utils/getPath'
import RootContainer from './containers/Root'
import ListContainer from './containers/List'
import FormContainer from './containers/Form'
import AdminFormContainer from './containers/AdminForm'
import DetailsContainer from './containers/Details'

const programRoutes = (
  <Route
    component={RootContainer}
    key="program-routes"
    path={getPath('backend', '/program')}
  >
    <IndexRoute component={ListContainer} />
    <Route
      path={getPath('backend', '/program/create')}
      component={FormContainer}
    />
    <Route
      path={getPath('backend', '/program/:id')}
      component={DetailsContainer}
    />
    <Route
      path={getPath('backend', '/program/:id/edit')}
      component={FormContainer}
    />
    <Route
      path={getPath('backend', '/program/:id/admin')}
      component={AdminFormContainer}
    />
  </Route>
)

export default programRoutes



// WEBPACK FOOTER //
// ./src/program/routes.js